import { useMemo, useReducer } from 'react'
import { initialState, reducer } from '../../state'
import type { Actions } from '../../state'
import type { State } from '../../state'
import { AsyncDispatch, wrapAsync } from '@sales-center/common'

export function useData() {
  const [state, dispatch] = useReducer(reducer, initialState)

  const asyncDispatch = useMemo(() => wrapAsync(dispatch), [dispatch])

  const value: [State, AsyncDispatch<Actions>] = [state as State, asyncDispatch]

  return {
    value,
  }
}
